import { Component } from '@angular/core';
import { StoreComponentDef } from '@df/catalog-ui/store/store.component.def';
import { Nexus } from '@tomandco/nexus-api-types';
import find from 'lodash-es/find';
@Component({
    selector: 'checkout-store-pickup-store',
    template: '<div [innerHTML]="addressString"></div>',
    standalone: true
})
export class CheckoutStorePickupStoreComponent extends StoreComponentDef {
    get addressString(): string {
        const modelData = this.model?.data;
        if (modelData) {
            return [modelData.store_name, modelData.address, modelData.city, modelData.postcode, this.getCountryName()]
                .filter(i => !!i)
                .join(', ');
        }
        return '';
    }
    private getCountryName(): string | undefined {
        const countryId = this.model?.data?.country_id;
        if (countryId) {

            return this.getCountryFromAddress(countryId)?.name;
        }
        return undefined;
    }


    private getCountryFromAddress(countryId: string): Nexus.Lib.General.Country | undefined {
        return countryId ? find(this.app.apiConfigService.countries, country => country.code === countryId) : undefined;
    }
}
